import { render, staticRenderFns } from "./InternetConference.vue?vue&type=template&id=5afae44b&scoped=true"
import script from "./InternetConference.vue?vue&type=script&lang=js"
export * from "./InternetConference.vue?vue&type=script&lang=js"
import style0 from "./InternetConference.vue?vue&type=style&index=0&id=5afae44b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afae44b",
  null
  
)

export default component.exports